import styled from 'styled-components/macro'
import { media } from '../../../../ui/rwd'
import { theme } from 'styled-tools'
import SlickSlider from 'react-slick/lib'
import { MdPlayCircleOutline } from 'react-icons/md'

const SlideItemImage = styled.img`
  width: 100%;
`

const SlideItemPlay = styled(MdPlayCircleOutline)`
  position: absolute;
  width: 96px;
  height: 96px;
  left: 50%;
  top: 50%;
  margin-left: -48px;
  margin-top: -48px;
  color: ${theme('yellow')};
`

const SlideButton = styled.button`
  background-color: white;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 1.5rem;
  height: 5rem;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: black;
  border: none;
  outline: none;
  &:focus {
    outline: 0;
  }
`

const NextSlide = styled(SlideButton)`
  right: 0;
`

const PrevSlide = styled(SlideButton)`
  left: 0;
  z-index: 2;
`

const Slider = styled(SlickSlider)`
  &.slick-slider {
    width: 320px;
    .slick-dots {
      bottom: 0;
      left: 0;
      top: auto;
      padding-right: 0.8rem;
      padding-bottom: 0.8rem;
      text-align: right;
      li {
        margin: 0;
        button:before {
          font-size: 10px;
        }
        &.slick-active {
          button:before {
            color: white;
            text-shadow: 1px 1px 1px #969696;
          }
        }
      }
    }
    ${media.md`
      width: 400px;
    `}
    .slick-list {
      width: 100%;
    }
  }
`

export {
  Slider,
  PrevSlide,
  NextSlide,
  SlideButton,
  SlideItemPlay,
  SlideItemImage
}
